import React from "react";

const FloorIcon = ({ className = "" }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    className={className}
  >
    <path
      stroke="#354052"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M1 19h18M17 6.62V15zM3 1.38V9zM18 7 2 1zM2 9v10h16v-4h-4v-2h-4v-2H6V9z"
    ></path>
  </svg>
);

export default FloorIcon;
